module.exports = __webpack_public_path__ + "static/media/clouds.c55cd546.svg";